// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"style__componentWrapper__-9o+S","body":"style__body__JcWh7"};